<template>
  <div class="label-list" :class="{ 'label-list-top': hasTop }">
    <tag-labels v-if="type === 'tag'" :labels="labelList" :compression="compression" :entityType="entityType" />
    <alert-labels
      v-if="type === 'alert'"
      :labels="labelList"
      :compression="compression"
      :invoiceExcessReason="invoiceExcessReason"
      :submitedDate="submitedDate"
      :hasPadding="hasPadding"
    />
  </div>
</template>

<script>
import TagLabels from 'components/business/label/tag-labels';
import useLabels from 'components/business/label/hooks/use-labels';
import AlertLabels from 'components/business/label/alert-labels';

export default {
  name: 'label-ui',
  components: { AlertLabels, TagLabels },
  data() {
    return {
      labelList: [],
    };
  },
  methods: {
    init() {
      const {
        compression,
        entityType = this.$store.getters.getEntityType,
        labels,
        scene = this.$store.getters.getSceneCode,
      } = this;
      this.labelList = useLabels({ compression, entityType, labels, scene: scene || 101 });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    labels() {
      this.init();
    },
  },
  props: {
    type: {
      // 标签类型 tag | alert
      type: String,
    },
    labels: {
      // 标签list
      type: Array,
    },
    scene: {
      // 场景
      type: Number,
    },
    compression: {
      // 是否过滤info
      type: Boolean,
    },
    entityType: {
      // 表单类型
      type: Number,
    },
    hasTop: {
      // 是否需要上外边距
      default: true,
      type: Boolean,
    },
    hasPadding: {
      // 是否需要上内边距
      default: true,
      type: Boolean,
    },
    submitedDate: {
      // 业务 提交日期
      type: String,
    },
    invoiceExcessReason: {
      // 业务 特殊属性
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.label-list {
  &-top {
    padding-top: 16px;
  }

  &:empty {
    display: none;
  }
}
</style>
